import { Router } from 'director';

export default new Router();



// WEBPACK FOOTER //
// ./src/service/router.js